import { Injectable } from '@angular/core';

import { Observable, take } from 'rxjs';
import { CustomSellerInfo } from '../common/CustomSellerInfo';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root'
})
export class CustomSellerInfoService extends ApiServiceBase {
  protected readonly path = 'customsellerinfo';

  get(id: string): Observable<CustomSellerInfo> {
    return this.http.get<CustomSellerInfo>(this.getUrl() + '/' + id);
  }

  getForCustomer(customerId: string): Observable<CustomSellerInfo> {
    return this.http.get<CustomSellerInfo>(this.getUrl() + '/forcustomer/' + customerId);
  }

  getBrandImage(customerId: string): Observable<Blob> {
    return this.http.get(this.getUrl() + '/brandimage/' + customerId, { responseType: 'blob' });
  }

  create(customSellerInfo: CustomSellerInfo): Observable<CustomSellerInfo> {
    return this.http.post<CustomSellerInfo>(this.getUrl(), customSellerInfo);
  }

  update(customSellerInfo: CustomSellerInfo): Observable<CustomSellerInfo> {
    return this.http.put<CustomSellerInfo>(this.getUrl() + '/' + customSellerInfo.id, customSellerInfo);
  }

  updateBrandImage(customerId: string, image: Blob): Observable<CustomSellerInfo> {
    const formData: FormData = new FormData();
    formData.append('Image', image, 'test');
    return this.http.put<CustomSellerInfo>(this.getUrl() + "/brandimage/" + customerId, formData, { params: { customerId: customerId } })
      .pipe(take(1));
  }
}
